// import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";


export default function Navbar(props) {
  const handleAboutUsTitleChange = () => {
    document.title = "TextUtils - About Us";
  }
  const handleHomeTitleChange = () => {
    document.title = "TextUtils - Home";
  }
  const handleTextUtilsTitleChange = () => {
    document.title = "TextUtils - Pranav Arya";
  }
  return (
    <>
      <nav className={`navbar navbar-expand-lg navbar-dark bg-${props.mode} bg-body-tertiary`}>
      {/* <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode} bg-body-tertiary`}> */}
        <div className="container-fluid">
          <Link className="navbar-brand" to="/textutils" onClick={handleTextUtilsTitleChange}>
            {props.title}
          </Link>
          {/* <a className="navbar-brand" href="#" onClick={handleTextUtilsTitleChange}>
            {props.title}
          </a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/home" onClick={handleHomeTitleChange}>
                  Home
                </Link>
                {/* <a className="nav-link active" aria-current="page" href="#" onClick={handleHomeTitleChange}>
                  Home
                </a> */}
              </li>
              <li className="nav-item">
                <Link className="nav-link active" to="/about" onClick={handleAboutUsTitleChange}>
                  {props.aboutText}
                </Link>
                {/* <a className="nav-link active" href="#" onClick={handleAboutUsTitleChange}>
                  {props.aboutText}
                </a> */}
              </li>
            </ul>
            {/* <form className="d-flex" role="search">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-outline-primary" type="submit">
                Search
              </button>
            </form> */}
            {/* <div className={`form-check form-switch text-${props.mode === 'primary' ? 'light' : 'light'}`}> */}

            {/* <div style={{marginRight: "10px"}}> */}
              {/* <img src="images\Red\circle-32.png" alt="Red Circle" onClick={props.toggleOnClickRedImg} style={{cursor: "pointer"}}/> */}
              {/* <img src={process.env.PUBLIC_URL + '/images/Red/circle-32.png'} alt="Red Circle" onClick={props.toggleOnClickRedImg} style={{cursor: "pointer"}}/> */}
            {/* </div> */}
            {/* <div style={{marginRight: "10px"}}> */}
              {/* <img src="images\Green\circle-32.png" alt="Green Circle" onClick={props.toggleOnClickGreenImg} style={{cursor: "pointer"}}/> */}
              {/* <img src={process.env.PUBLIC_URL + '/images/Green/circle-32.png'} alt="Green Circle" onClick={props.toggleOnClickGreenImg} style={{cursor: "pointer"}}/> */}
            {/* </div> */}
            {/* <div style={{marginRight: "10px"}}> */}
              {/* <img src="images\Yellow\circle-32.png" alt="Yellow Circle" onClick={props.toggleOnClickYellowImg} style={{cursor: "pointer"}}/> */}
              {/* <img src={process.env.PUBLIC_URL + '/images/Yellow/circle-32.png'} alt="Yellow Circle" onClick={props.toggleOnClickYellowImg} style={{cursor: "pointer"}}/> */}
            {/* </div> */}
            
            {/* <img src="images\Red\circle-32.png" alt="Another Red" /> */}
            {/* <img src={require('/images/Red/circle-32.png')} /> */}
            <div className="form-check form-switch text-light">
                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={props.toggleMode}/>
                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{props.navBtnName}</label>
              </div>
          </div>
        </div>
      </nav>
    </>
  );
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  // aboutText: PropTypes.string.isRequired,
};

Navbar.defaultProps = {
  title: "Set Title Here",
  // aboutText: "Set About Text Here",
};
